import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('Bin?page=' + page, {params});
    },
}